/**
 * Dictation lever (2026-09-09). Default-ON, opt-out — the same shape as the
 * readout's and the reactions':
 *
 *   REACT_APP_DICTATION=off
 *
 * The server has its own kill switch (PREST0N_DICTATION=off). This one takes
 * the microphone off the composer.
 */
export function dictationEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_DICTATION ?? '').trim().toLowerCase() !== 'off';
}

/**
 * Can this browser reach a microphone at all?
 *
 * Checked because the alternative is a button that does nothing: a dead control
 * is worse than an absent one, so the composer simply does not render the
 * microphone where this is false (an insecure context, a locked-down embed, an
 * old browser).
 */
export function microphoneAvailable(nav: Navigator | undefined = typeof navigator === 'undefined' ? undefined : navigator): boolean {
  return Boolean(nav?.mediaDevices && typeof nav.mediaDevices.getUserMedia === 'function');
}
